import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Don't throw during SSR / build. Throw at first real call instead.
  console.warn('[supabase] VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY is missing.');
}

export const supabase = createClient(url ?? 'http://localhost:54321', anonKey ?? 'local-anon-key', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'fw-auth',
    flowType: 'pkce',
  },
  global: {
    headers: { 'x-fw-client': 'web' },
  },
});
